"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalReasonEnum = exports.EntityTypeEnum = exports.ExperienceTypeEnum = exports.SkillTypeEnum = exports.JobSearchStatusEnum = exports.JobChangeCountEnum = exports.EmploymentTypeEnum = exports.EmploymentStatusEnum = exports.RelocationPreferenceEnum = exports.GraduationStatusEnum = exports.EducationLevelEnum = exports.ProficiencyEnum = exports.GenderEnum = void 0;
const zod_1 = __importDefault(require("zod"));
// *************** Candidate Attributes ***************
exports.GenderEnum = zod_1.default.enum([
    'FEMALE',
    'MALE',
    'PREFER_NOT_TO_SAY',
]);
exports.ProficiencyEnum = zod_1.default.enum([
    'BASIC',
    'INTERMEDIATE',
    'ADVANCED',
    'NATIVE',
]);
// *************** Education ***************
exports.EducationLevelEnum = zod_1.default.enum([
    'HIGH_SCHOOL',
    'VOCATIONAL_SCHOOL',
    'TECHNICAL_COLLEGE',
    'JUNIOR_COLLEGE',
    'UNIVERSITY',
    'BACHELOR',
    'MASTER',
    'GRADUATE_SCHOOL',
    'OTHER',
]);
exports.GraduationStatusEnum = zod_1.default.enum([
    'GRADUATED',
    'EXPECTED_TO_GRADUATE',
    'PENDING',
]);
exports.RelocationPreferenceEnum = zod_1.default.enum([
    'POSITIVE',
    'NEGATIVE',
    'NEUTRAL',
]);
// *************** Employment ***************
exports.EmploymentStatusEnum = zod_1.default.enum([
    'EMPLOYED',
    'UNEMPLOYED',
    'NO_EXPERIENCE',
]);
exports.EmploymentTypeEnum = zod_1.default.enum([
    'FULL_TIME',
    'PART_TIME',
    'CONTRACT',
    'FREELANCE',
    'INTERNSHIP',
    'TEMPORARY',
]);
exports.JobChangeCountEnum = zod_1.default.enum([
    'ZERO',
    'ONE',
    'TWO',
    'THREE',
    'FOUR',
    'FIVE_OR_MORE',
]);
exports.JobSearchStatusEnum = zod_1.default.enum([
    'APPLYING_TO_COMPANY',
    'OPEN_TO_OFFERS',
    'NOT_ACTIVELY_LOOKING',
]);
// *************** Misc ***************
exports.SkillTypeEnum = zod_1.default.enum(['SKILL', 'IT']);
exports.ExperienceTypeEnum = zod_1.default.enum(['INDUSTRY', 'OCCUPATION']);
exports.EntityTypeEnum = zod_1.default.enum(['INDUSTRY', 'PROVINCE', 'OCCUPATION']);
exports.WithdrawalReasonEnum = zod_1.default.enum([
    'FOUND_JOB_PLUS_UP',
    'FOUND_JOB_OTHER',
    'STOP_JOB_SEARCH',
    'SITE_DIFFICULT',
    'OTHER',
]);
